module.exports = __webpack_public_path__ + "assets/img/fangan02.8d3209cb.png";